module.exports = __webpack_public_path__ + "media/images/top/pickup-001048ac9000985adc624a1dc71a16fd.svg";